import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { WorkCenterDto } from '@app/generated/model';

export const buildWorkCenterForm = (formBuilder: UntypedFormBuilder, workCenter: WorkCenterDto): UntypedFormGroup => {
  const form = formBuilder.group({
    id: [{ value: '', disabled: true }, Validators.required],
    name: ['', Validators.required],
    number: ['', Validators.required],
  });

  form.patchValue(workCenter);

  return form;
};
